export const segmentLabels = { attivita: "Attività", tempo_morto: "Tempo morto", fuori_presenza: "Fuori presenza conteggiata" };
export function dayOffset(day, amount) {
    const date = new Date(`${day}T12:00:00Z`);
    date.setUTCDate(date.getUTCDate() + amount);
    return date.toISOString().slice(0, 10);
}
export function clockTime(value) {
    return new Intl.DateTimeFormat("it-IT", { timeZone: "Europe/Rome", hour: "2-digit", minute: "2-digit" }).format(new Date(value));
}
export function activityLabel(activity) {
    return [activity.ordine, activity.fase, activity.causale, activity.centro].filter(Boolean).join(" · ");
}
export function validDay(data, person, day) {
    return data?.id === person && data?.giorno === day &&
        ["presenze", "attivita", "segmenti"].every(key => Array.isArray(data[key])) &&
        Number.isFinite(Date.parse(data.inizio_giornata)) && Number.isFinite(Date.parse(data.fine_giornata));
}
